import React  from 'react';


const ManageOrder = () => {

    return (
        <div>
            <div className="flex justify-end bg-accent p-5 rounded-lg my-8 mt-[-55px]">
                <h2 className='text-xl font-semibold'>Total order: 54</h2>
            </div>
            <div className="overflow-x-auto">
                <table className="table w-full">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Order</th>
                            <th>Buyer</th>
                            <th>Quantity</th>
                            <th>Manage</th>
                        </tr>
                    </thead>
                    <tbody>
                        
                            {/* order.map((a, index) => <tr key={a._id}>
                              <th>{index + 1}</th>
                                 <td>{a.orderName}</td>
                              <td>{a.buyerName}/per</td>
                                <td>{a.quantity}</td> */}
                                {/* <td className='text-center' style={{ width: '100px' }}>
                                    <button onClick={() => handleDelete(a._id)} className='btn btn-sm btn-info shadowmx-1'>Delete</button>
                              </td> */}
                            {/* </tr>) */}
                       

                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ManageOrder;